import React from 'react';
import styled from 'styled-components';

const CurrentResultMessage = () => (
  <div>
    <p>
      This data is being updated in real time. When your freeze is complete, you will be informed by
      the embryology team.
    </p>
  </div>
);

export default styled(CurrentResultMessage)`
  div {
    color: ${({ theme }) => theme.colors.white};
    p {
      ${({ theme }) => theme.typos.bodyText};
      margin-bottom: 16px;
    }
  }
`;
